import React, { useContext, useEffect, useLayoutEffect, useRef } from 'react';
import { ThemeProvider } from 'react-jss';
import { useFullscreen } from 'react-use';
import { Route, Routes } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
// import { TourProvider } from '@reactour/tour';
import ThemeContext from '../contexts/themeContext';
import Aside from '../layout/Aside/Aside';
import Wrapper from '../layout/Wrapper/Wrapper';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import useDarkMode from '../hooks/useDarkMode';
import COLORS from '../common/data/enumColors';
import { getOS } from '../helpers/helpers';
// import steps, { styles } from '../steps';

const App = () => {
	getOS();

	/**
	 * Dark Mode
	 */
	const { themeStatus, darkModeStatus } = useDarkMode();
	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};

	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	/**
	 * Full Screen
	 */
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	/**
	 * Modern Design
	 */
	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	//	Add paths to the array that you want to be "Aside".
	const withAsidePages = [
		'/',
		'Unit',
		'Unit/create',
		'Unit/edit/:id',
		'Unit/detail/:id',
		'residents',
		'guests/edit/:id',
		'residents/create',
		'residents/detail/:id',
		'residents/edit/:id',
		'revenue',
		'revenue/detail/:id',
		'reservation',
		'reservation/update/:id',
		'reservation/detail/:id',
		'rates',
		'rates/change_rates',
		'change_price/edit/:id/:index',
		'change_price/edit/per_hour/:id/:index',
		'change_price/detail/:id',
		'change_price/detail',
		'change_price',
		'single-pages/fluid',
		'single-pages/vehicle-colors',
		'single-pages/vehicle-rentals',
		'single-pages/cancellation-Requests',
		'guests',
		'guests/create',
		'guests/detail/:id',
		'residents-vehicles',
		'change_rates',
		'vehicles',
		'vehicles/create',
		'vehicles/edit/:id',
		'vehicles/detail/:id',
		'partners',
		'partners/create',
		'partners/edit/:id',
		'partners/detail/:id',
		'profile',
	];

	return (
		<ThemeProvider theme={theme}>
			<ToastProvider components={{ ToastContainer, Toast }}>
				{/* <TourProvider
					steps={steps}
					styles={styles}
					showNavigation={false}
					showBadge={false}
				> */}
				<div
					ref={ref}
					className='app'
					style={{
						backgroundColor: fullScreenStatus && 'var(--bs-body-bg)',
						zIndex: fullScreenStatus && 1,
						overflow: fullScreenStatus && 'scroll',
					}}
				>
					<Routes>
						{withAsidePages.map((path) => (
							<Route key={path} path={path} element={<Aside />} />
						))}
						<Route path='*' />
					</Routes>
					<Wrapper />
				</div>
				{/* </TourProvider> */}
			</ToastProvider>
		</ThemeProvider>
	);
};

export default App;
